import { render } from "./ModalBookshelfDelete.vue?vue&type=template&id=048a5582&scoped=true"
import script from "./ModalBookshelfDelete.vue?vue&type=script&lang=js"
export * from "./ModalBookshelfDelete.vue?vue&type=script&lang=js"

import "./ModalBookshelfDelete.vue?vue&type=style&index=0&id=048a5582&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048a5582"]])

export default __exports__